module.exports = __webpack_public_path__ + "a2152a39258100ef9baff3b3a219a734.svg";